import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {},
  spacesAvailable: {
    fontWeight: "bold",
  },
}));
